module.exports = __webpack_public_path__ + "static/FontAwesome5_Regular-f6c6f6c8cb7784254ad00056f6fbd74e.ttf";